import { format } from "date-fns";

/**
 * A file name that says what it holds and when it was made.
 *
 * Reduced to what a file name can carry on every platform: the parts that identify it are free
 * text — a vehicle name, a database name — and routinely contain slashes and umlauts.
 *
 * @param prefix - What kind of file this is, in plain ASCII.
 * @param name - What it is about; dropped when it reduces to nothing.
 * @param date - The day it belongs to, in the local calendar.
 */
export function exportFileName(prefix: string, name: string, date: Date): string {
  return [prefix, slug(name), format(date, "yyyy-MM-dd")].filter(Boolean).join("-") + ".xlsx";
}

function slug(name: string): string {
  return name
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
